import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { UpdateInfoActionTypes, UpdateInfoActions } from '../actions/update-info.actions';


@Injectable()
export class UpdateInfoEffects {


  // @Effect()
  // loadUpdateInfos$ = this.actions$.pipe(
  //   ofType(UpdateInfoActionTypes.UPDATE_INFO_SUCCESS),
  //   /** An EMPTY observable only emits completion. Replace with your own observable API request */
  //   concatMap(() => EMPTY)
  // );


  private actions$ = inject(Actions);


  constructor() {}

}
